import React from 'react';
import { Route, Routes } from 'react-router';
import Report from './report/Report';
import User from './user/User';
import Role from './role/Role';
import Interface from './interface/Interface';
import Action from './action/Action';
import Protocol from './protocol/Protocol';
import Schema from './schema/Schema';

const AppRoutes = ({ spinner, enableHelp }) => (
    <Routes>
        <Route path="index.reports/*" element={<Report spinner={spinner} enableHelp={enableHelp} />} />
        <Route path="index.users" element={<User spinner={spinner} />} />
        <Route path="index.roles" element={<Role spinner={spinner} />} />
        <Route path="index.interfaces" element={<Interface spinner={spinner} />} />
        <Route path="index.actions" element={<Action spinner={spinner} />} />
        <Route path="index.logs" element={<Protocol spinner={spinner} />} />
        <Route path="index.schemas" element={<Schema spinner={spinner} />} />
    </Routes>
);

export default AppRoutes;
